import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { Register } from '@xanadu/core';

@Component({
    selector: 'app-slider-meta',
    templateUrl: './slider-meta.component.html',
    styleUrls: ['./slider-meta.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('slider-meta')
export class SliderMetaComponent {
    model = input<any>();

    metaMin: any = { id: 'min', name: 'Minimum' };
    metaMax: any = { id: 'max', name: 'Maximum' };
    metaStep: any = { id: 'step', name: 'Step' };
}

